<label>
  <span>YouTube URL</span>
  <input
    [ngModel]="block.youTubeUrl"
    placeholder="https://www.youtube.com/watch?v=..."
    (ngModelChange)="updateYouTubeUrl($event)" />
</label>
